'use strict';

var SSWidgetServiceProvider = function () {

    var Widget = undefined;

    var widgetInstance = undefined;

    var params = {
        dealerId: '',
        culture: '',
        externalStylesUrl: '',
        url: '',
        token: '',
        tag: '',
        enabled: true
    };

    var EVENTS = {
        ON_LOAD: 'on_ss_widget_load',
        ON_ERROR: 'on_ss_widget_error',
        ON_SURVEYS_LIST: 'on_ss_surveys_list',
        ON_SURVEY_SAVE: 'on_ss_survey_save',
        ON_SURVEY_CANCEL: 'on_ss_survey_cancel'
    };

    var subscriptions = [];

    var availableSurveysList = [];
    var surveyContent = [];

    function uuid() {

        var currentDate = new Date().getTime();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            currentDate += performance.now();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (ch) {
            var r = (currentDate + Math.random() * 16) % 16 | 0;
            currentDate = Math.floor(currentDate / 16);
            return (ch === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    this.init = function (url, enabled) {

        params.enabled = enabled;

        if (!params.enabled) {
            return;
        }

        var script = document.createElement('script');

        script.setAttribute('src', url + '/widget/widget.js');

        script.addEventListener('load', function (ev) {

            Widget = window.DfxServiceDiagnosticsSheets;
            params.url = url;
            params.sessionId = Widget.generateUUID();

        }, false);

        script.addEventListener('error', function (ev) {
            params.enabled = false;
        }, false);

        document.head.appendChild(script);
    };

    function triggerEvent(ev, data) {
        subscriptions
            .filter(function (el) {
                return el.event === ev;
            })
            .forEach(function (el) {
                el.cb.call(null, data)
            })
    }

    this.$get = ['$state', '$q', '$timeout', function ($state, $q, $timeout) {
        return {
            isEnabled: function () {
                return params.enabled;
            },
            disable: function () {
                params.enabled = false;
            },
            dropSession: function () {
                if (params.enabled) {
                    params.sessionId = Widget.generateUUID();
                }
            },
            setSessionId: function (val) {
                params.sessionId = val;
            },
            initWidget: function (externalStylesUrl, token, dealerId, culture) {
                if (!params.enabled) {
                    return false;
                }

                if (!Widget || !Widget.TargetApplication) {
                    params.enabled = false;
                    console.error('Widget instance cannot be initialized');
                    return false;
                }

                widgetInstance = Widget.TargetApplication(
                    externalStylesUrl,
                    token,
                    dealerId,
                    culture,
                    params.url,
                    {
                        showDealerRelatedContent: false
                    }
                );
            },
            loadWidget: function (el, survey, surveyContent) {

                var deferred = $q.defer();

                if (!params.enabled) {
                    $timeout(function () {
                        triggerEvent(EVENTS.ON_LOAD, null);
                    });
                    return;
                }

                if (!widgetInstance) {
                    throw new Error('Widget instance has not been initialized');
                }

                if (widgetInstance.isRunning) {
                    widgetInstance.destroy();
                }

                widgetInstance.init(el, params.sessionId, survey, surveyContent);

                widgetInstance.onWidgetLoad(function (ev) {
                    triggerEvent(EVENTS.ON_LOAD, ev);
                    deferred.resolve(ev);
                });

                widgetInstance.onOpenSurvey(function (ev) {
                    if (widgetInstance.isRunning) {
                        widgetInstance.destroy();
                    }
                    // save additional survey content
                    surveyContent = ev.surveyContent;
                    // navigate to the view with widget container
                    // $state.go('bookappointment.survey', { survey: ev.survey, name: ev.name });
                });

                widgetInstance.onError(function (ev) {
                    triggerEvent(EVENTS.ON_ERROR, ev);
                    deferred.reject(ev);
                });

                widgetInstance.onSurveyCancel(function (ev) {
                    // widgetInstance.destroy();
                    triggerEvent(EVENTS.ON_SURVEY_CANCEL, ev);
                    //     $state.go('bookappointment.concerns');
                });

                widgetInstance.onSurveySave(function (ev) {
                    triggerEvent(EVENTS.ON_SURVEY_SAVE, ev);
                });

                // widgetInstance.onLoadSurveys(function(ev) {
                //     availableSurveysList = ev.surveys.filter(function(el) {
                //         return el.hasData;
                //     }) || [];
                //     triggerEvent(EVENTS.ON_SURVEYS_LIST, availableSurveysList);
                // });

                widgetInstance.onSurveyRemove(function (ev) {
                    return Promise.resolve(true);
                });

                return deferred.promise;
            },
            resolveAvailableSurveys: function () {
                return widgetInstance.getAvailableSurveysList(params.sessionId)
                    .then(function (data) {
                        // TODO filter recall-deferment
                        availableSurveysList = data;
                        triggerEvent(EVENTS.ON_SURVEYS_LIST, availableSurveysList);
                        return data;
                    }.bind(this))
            },
            getAvailableSurveyTemplates: function () {
                return availableSurveysList;
            },
            addTag: function (tagValue, tagType) {
                if (!params.enabled) {
                    return $q.resolve(null);
                }
                return widgetInstance.addTag(tagValue, tagType, params.sessionId);
            },
            onLoad: function (cb) {
                var id = uuid();
                subscriptions.push({
                    id: id,
                    event: EVENTS.ON_LOAD,
                    cb: cb
                });
                return id;
            },
            onError: function (cb) {
                var id = uuid();
                subscriptions.push({
                    id: id,
                    event: EVENTS.ON_ERROR,
                    cb: cb
                });
                return id;
            },
            onGetAvailableSurveysList: function (cb) {
                var id = uuid();
                subscriptions.push({
                    id: id,
                    event: EVENTS.ON_SURVEYS_LIST,
                    cb: cb
                });
                return id;
            },
            onSurveySave: function (cb) {
                var id = uuid();
                subscriptions.push({
                    id: id,
                    event: EVENTS.ON_SURVEY_SAVE,
                    cb: cb
                });
                return id;
            },
            onSurveyCancel: function (cb) {
                var id = uuid();
                subscriptions.push({
                    id: id,
                    event: EVENTS.ON_SURVEY_CANCEL,
                    cb: cb
                });
                return id;
            },
            off: function (id) {
                subscriptions = subscriptions.filter(function (el) {
                    return el.id !== id;
                });
            },
            destroy: function () {
                subscriptions = [];
                widgetInstance.destroy();
            },
            getCurrentSurveyContent: function () {
                return surveyContent;
            },
            setCurrentSurveyContent: function (value) {
                surveyContent = value;
            },
            removeSurveyInstance: function (self) {
                return widgetInstance.removeSurveyInstance(self);
            },
            getSurveyAssociatedToService: function (serviceId) {
                try{
                    return widgetInstance.getSurveyAssociatedToService(serviceId, params.sessionId);
                }
                catch (e) {
                    return $q.resolve([]);
                }
            }
        }
    }];
};

module.exports = SSWidgetServiceProvider;
